import { render, staticRenderFns } from "./PurchaseEmployee.vue?vue&type=template&id=02f67673"
import script from "./PurchaseEmployee.vue?vue&type=script&lang=js"
export * from "./PurchaseEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports